import { createGenericSlice } from './GenericSlice';
export const initialState = {
    loading: false,
    error: false,
    response: {},
    other: false,
};
// const contentfulSlice = createSlice({
//   name: 'Contentful',
//   initialState: initialState,
//   reducers: {
//     fetchContent(state: ContentfulState, action?: PayloadAction<ContentfulPayload>) {
//       state.loading = true;
//       console.log(action);
//     },
//     fetchContentSuccess(state: ContentfulState, action: PayloadAction<EntryCollection<any>>) {
//       state.loading = false;
//       state.response = action.payload;
//     },
//     fetchContentFailed(state: ContentfulState, action: PayloadAction<string>) {
//       state.loading = false;
//       state.error = true;
//       console.warn(action);
//     },
//   },
// });
const contentfulSlice = createGenericSlice('Contentful', initialState);
// Name
export const sliceName = contentfulSlice.name;
// Actions
export const contentfulActions = contentfulSlice.actions;
// Selectors
export const selectContentfulResponse = (state) => state.contentfulReducer?.response;
// Reducer
const contentfulReducer = contentfulSlice.reducer;
export default contentfulReducer;
